import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import './index.css';

import "./styles/global.css";
import "./styles/login.css";
import "./styles/dashboard.css";
import "./styles/buttons.css";
import "./styles/accountSelector.css";
import "./styles/profileInfo.css";
import "./styles/datesSelector.css";
import "./styles/navbar.css"
import "./styles/landingpage.css"
import "./styles/reportCard.css";
import "./styles/reportRows.css";
import "./styles/reportTable.css";
import "./styles/app-pages.css";
import "./styles/grouping.css";
import "./styles/companies.css";
import "./styles/loading.css";
import "./styles/notfound.css";
import "./styles/exports.css";
import "./styles/uiCards.css";
import "./styles/removedItems.css";
import "./styles/generatePage.css";
import "./styles/reportFilters.css";
import "./styles/presetBar.css";
import "./styles/policy.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
